
'use strict';
import {Injectable} from 'ng-metadata/core';

import {OpacService} from '../opac.service';

@Injectable()
export class RequestServicesService {

    constructor(private opacService  :OpacService) {
    }

    /* private functions */
    public updateIlsServices(services) {
           this.opacService.getServices();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestsService.service.ts